var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"accreditation-details-layout"},[_c('main',{staticClass:"accreditation-details-main-column"},[_vm._t("main")],2),_c('aside',{staticClass:"accreditation-details-side-column"},[_vm._t("sidebar")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }